export default __webpack_public_path__ + "static/media/icon-logo-new.7fdd6a57.svg";